export default "__VITE_ASSET__DxYyOEtO__"